import {
  Alert,
  Badge,
  List,
  Modal,
  Skeleton,
  Space,
  Tag,
  Typography,
} from 'antd';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

const {Text} = Typography;

const LowStockModal = ({
  isModalOpen,
  setIsModalOpen,
  lowStockProducts = [],
  isLoading,
}) => {
  const navigate = useNavigate();

  const handleClose = () => setIsModalOpen(false);

  return (
    <Modal
      title={'Raw Products Low Stock'}
      open={isModalOpen}
      onOk={handleClose}
      onCancel={handleClose}
      width={500}
      Styles={{
        maxHeight: '500px',
        overflowY: 'auto',
        background: '#f8fafc',
      }}
    >
      {isLoading ? (
        <Skeleton active />
      ) : lowStockProducts.length === 0 ? (
        <Alert
          type={'success'}
          message={'No products are low in stock 🎉'}
          showIcon
        />
      ) : (
        <List
          itemLayout={'vertical'}
          dataSource={lowStockProducts}
          renderItem={item => (
            <List.Item
              className={
                'group cursor-pointer rounded-2xl border border-primary-200 bg-white p-0 my-4 overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1'
              }
              onClick={() =>
                navigate('/admin/products', {
                  state: {openEdit: true, productId: item.id},
                })
              }
            >
              <div className={'flex w-full'}>
                {/* Left Status Strip */}

                <div className={'flex justify-between w-full p-5'}>
                  {/* Header */}
                  <div className={'flex justify-between items-start'}>
                    <div>
                      <h3 className={'text-lg font-bold text-gray-800'}>
                        {item?.productName}
                      </h3>

                      <p className={'text-sm text-gray-500 mt-1'}>
              EAN : {item?.eanCode || '--'}
                      </p>
                    </div>
                    
                  </div>  

                  <div className={'mt-2'}>
                    <Tag
                      color={Number(item?.quantity) === 0 ? 'red' : 'orange'}
                      className={'rounded-full px-4 py-1 font-semibold'}
                    >
                      {Number(item?.quantity) === 0
                        ? 'Out of Stock'
                        : 'Low Stock'}
                    </Tag>
                  </div>               

                  {/* Footer */}
                  <div className={' flex justify-end items-center'}>
                    <Tag
                      color={Number(item?.quantity) === 0 ? 'red' : 'volcano'}
                      className={'rounded-full px-4 py-1 text-sm font-bold'}
                    >
             Qty : {item?.quantity ?? 0}
                    </Tag>
                    
                  </div>

                </div>
              </div>
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
};

LowStockModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  lowStockProducts: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default LowStockModal;
